export const couponStatusMap = {
  1: '未使用',
  2: '已使用',
  3: '已锁定',
  4: '已核销',
  5: '已删除',
  6: '已过期',
  7: '已退回'
}

export const cardTypeMap = {
  1: '机票券',
  2: '产品券',
  3: '外部'
}

export const cardTypeClassMap = {
  1: 'flight',
  2: 'ancillary',
  3: 'combo'
}

export const couponTypeMap = {
  0: '直减',
  1: '折扣'
}

export const sourceMap = {
  1: '海航App'
}
